import { render, staticRenderFns } from "./Resgate.vue?vue&type=template&id=1b8bb0ef&"
import script from "./Resgate.vue?vue&type=script&lang=js&"
export * from "./Resgate.vue?vue&type=script&lang=js&"
import style0 from "./Resgate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports